import type { ApiClient } from '~/api/types';

/**
 * Map of client ID to client data
 */
export type ClientsState = Record<string, ApiClient>;

export const initialStateClients: ClientsState = {};
